"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RankingLargestDeltas = void 0;
var axios_1 = __importDefault(require("axios"));
var React = __importStar(require("react"));
var react_1 = require("react");
var factorService_1 = require("../../../services/factorService");
var deltaArrowNumber_1 = require("./deltaArrowNumber");
var lodash_1 = __importDefault(require("lodash"));
var DeltaFactorBox = function (props) {
    var deltaFactorRanks = props.deltaFactorRanks, factorService = props.factorService;
    var delta = deltaFactorRanks[0], factorSlug = deltaFactorRanks[1];
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement("span", { className: "arrow" },
                React.createElement(deltaArrowNumber_1.DeltaArrow, { delta: delta })),
            React.createElement("span", { className: "number" }, delta)),
        React.createElement("div", { className: "name" },
            React.createElement("a", { href: "/ranking?factor=" + factorSlug }, factorService.getName(factorSlug)))));
};
exports.RankingLargestDeltas = function (props) {
    var municipality = props.municipality;
    var _a = react_1.useState(undefined), data = _a[0], setData = _a[1];
    react_1.useEffect(function () {
        axios_1.default.get('/rankings/by_largest_delta', { params: { municipality: municipality } }).then(function (r) {
            setData(r.data);
        }).catch(function (err) { return console.error(err); });
    }, [municipality, setData]);
    if (!data) {
        return React.createElement(React.Fragment, null);
    }
    var factorService = new factorService_1.FactorService();
    var tableRows = lodash_1.default.chain(data).chunk(2).map(function (pair) {
        var left = pair[0], right = pair[1];
        var leftSlug = left[1];
        var rightSlug = right[1];
        return React.createElement("tr", { key: leftSlug + "-" + rightSlug },
            React.createElement("td", null,
                React.createElement(DeltaFactorBox, { deltaFactorRanks: left, factorService: factorService })),
            React.createElement("td", null,
                React.createElement(DeltaFactorBox, { deltaFactorRanks: right, factorService: factorService })));
    }).value();
    return React.createElement("div", { className: "content" },
        React.createElement("div", { className: "title" }, "St\u00F6rsta f\u00F6r\u00E4ndringar"),
        React.createElement("table", null,
            React.createElement("tbody", null, tableRows)));
};
